<template>
  <section class="section-block">
    <div class="section-block__top">
      <h2 class="section-block__header">
        Reservdelar, JOHN DEERE 1020
      </h2>

      <!-- <div class="section-block__top-right">
        dropdown
      </div> -->
    </div>

    <div class="grid grid--five">
      <template v-for="category of categories">
        <div
          :key="category.id"
          v-accordion-level-list="{ closeOthers: false, mediaQuery: true, expandFirst: false }"
          class="accordion-level-list category-page-categories js-accordion-level-list">
          <a :href="`/reservdelar/${category.id}`" class="navigational-item navigational-item--arrow navigational-item--dark-blue">
            {{ category.name }}
          </a>

          <a
            v-for="subCategory of category.subCategories.slice(0, slice)"
            :key="subCategory.id"
            :href="`/reservdelar/${category.id}`"
            class="navigational-item navigational-item--arrow navigational-item--light-blue accordion-level-list__sub-item">{{ subCategory.name }}
          </a>

          <div
            v-if="category.subCategories.length >= slice"
            :id="`${category.id}-content`"
            :aria-labelledby="`${category.id}-toggler`"
            aria-hidden="true"
            class="accordion-level-list__hidden-sub-items">
            <a
              v-for="subCategory of category.subCategories.slice(slice)"
              :key="subCategory.id"
              :href="`/reservdelar/${subCategory.id}`"
              class="navigational-item navigational-item--arrow navigational-item--light-blue accordion-level-list__sub-item">{{ subCategory.name }}
            </a>
          </div>

          <button
            v-if="category.subCategories.length > slice"
            :id="`${category.id}-toggler`"
            :aria-controls="`${category.id}-content`"
            aria-expanded="false"
            class="interaction-item interaction-item--link-button accordion-level-list__toggle js-accordion-toggler">
            <div class="accordion-level-list__toggle-inner accordion-level-list__toggle-reveal">
              <oie-use-svg svg="expand-circle"></oie-use-svg>
              {{ tStatic('showMoreLink') }}
            </div>

            <div class="accordion-level-list__toggle-inner accordion-level-list__toggle-desmiss">
              <oie-use-svg svg="desmiss-circle"></oie-use-svg>
              {{ tStatic('closeLink') }}
            </div>
          </button>
        </div>
      </template>

      <div v-for="i of 4" :key="`category-top-list-${i}`" class="grid__item--filler"></div>
    </div>
  </section>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    categories: null,
    slice: 2
  }),
  watch: {
    '$route.params.category': {
      immediate: true,
      handler(categoryId) {
        httpService.get(`category/${categoryId}/subcategories`).then(({ data }) => {
          this.categories = data
        })
      }
    }
  }
}
</script>
